import axios from './axios'

const signUp = data => axios.post('/register/google', data)

const signIn = data => axios.post('/login', data)

const loginGuoogle = () => axios.get('/login/google/url')
const signUpGuoogle = () => axios.get('/register/google/url')

const deleteProfile = accessKey => axios.delete(`user?accessKey=${accessKey}`)

const checkAuth = (accessKey, date) => axios.get(`access/${accessKey}?timezoneOffset=${date}`)

const updateUser = (accessKey, data) => axios.put('user', {
  accessKey,
  ...data,
})

const obj = {
  signUp,
  signIn,
  loginGuoogle,
  deleteProfile,
  updateUser,
  signUpGuoogle,
  checkAuth,
}

export default obj
